import { AppData, Colors, Lightning } from '@lightningjs/sdk';
import { HoverableComponent } from 'components/common/HoverableComponent';
import QrCode from '../../../common/QrCode';
import { getQrCodeUrl } from 'support/loginRadiusUtils';

export interface LoginQrCodeTemplateSpec
  extends Lightning.Component.TemplateSpec {
  size: number;
  QrCode: typeof QrCode;
  onQrCodeChanged?: (code: string) => void;
}

export default class LoginQrCode
  extends HoverableComponent<LoginQrCodeTemplateSpec>
  implements Lightning.Component.ImplementTemplateSpec<LoginQrCodeTemplateSpec>
{
  private _QrCode = this.getByRef('QrCode')!;
  private _onQrCodeChanged: LoginQrCodeTemplateSpec['onQrCodeChanged'];

  set size(value: number) {
    this.patch({ w: value, h: value });
    this._QrCode.patch({ width: value, height: value });
  }

  set qrCodeString(value: string) {
    this._QrCode.load(value);
    this.onQrCodeChanged?.(value);
  }

  get onQrCodeChanged() {
    return this._onQrCodeChanged;
  }

  set onQrCodeChanged(
    onQrCodeChanged: LoginQrCodeTemplateSpec['onQrCodeChanged'],
  ) {
    this._onQrCodeChanged = onQrCodeChanged;
  }

  static override _template(): Lightning.Component.Template<Lightning.Component.TemplateSpecLoose> {
    return {
      rect: true,
      color: Colors('transparent').get(),
      QrCode: {
        type: QrCode,
      },
    };
  }

  override _enable() {
    this.startQrCodeTimer();

    window.backgroundingService.addBackgroundingAction(
      'qrBackgrounded',
      this._onBackgrounded.bind(this),
    );

    window.backgroundingService.addForegroundingAction(
      'qrForegrounded',
      this._onForegrounded.bind(this),
    );
  }

  override _inactive() {
    AppData?.qrLoginService?.reset();

    window.backgroundingService.removeBackgroundingAction('qrBackgrounded');
    window.backgroundingService.removeForegroundingAction('qrForegrounded');
  }

  private _onBackgrounded() {
    AppData?.qrLoginService?.pauseTimer();
  }

  private _onForegrounded() {
    this.startQrCodeTimer();
  }

  private startQrCodeTimer() {
    AppData?.qrLoginService?.setupQrCodeTimer({
      onQrCodeChanged: this.onQrCodeChangedCallback.bind(this),
      onLoginCompleted: this.onLoginCompleted.bind(this),
    });
  }

  private onQrCodeChangedCallback(qrCode?: string) {
    this.qrCodeString = getQrCodeUrl(qrCode);
  }

  private onLoginCompleted() {
    AppData?.modalService.open('SignInConfirmationModal');
  }
}
